import { jsxs as S, jsx as e } from "react/jsx-runtime";
import { useRef as T, useCallback as E, useEffect as W, forwardRef as L } from "react";
import { L as j } from "../index-CeQ14xPc.js";
import { c as z } from "../clsx-OuTLNxxd.js";
import { B as x } from "../Button-B2Q9lfS-.js";
import '../Dialog.css';const M = "_closeButton_zev34_32", P = "_dialog_zev34_36", X = "_hasBackdrop_zev34_52", Y = "_isFullScreen_zev34_55", $ = "_closeButtonWrapper_zev34_64", q = "_dialogWrapper_zev34_77", A = "_panel_zev34_91", a = {
  closeButton: M,
  dialog: P,
  hasBackdrop: X,
  isFullScreen: Y,
  closeButtonWrapper: $,
  dialogWrapper: q,
  panel: A
}, v = ({
  children: s,
  className: t,
  hasBackdrop: r = !0,
  isFullScreen: N = !1,
  isOpen: n = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: u = !0,
  title: p,
  triggerRef: l,
  ...b
}) => {
  const c = T(null), d = E(
    (o) => {
      var k, g, C;
      if (!u)
        return;
      const w = (k = c.current) == null ? void 0 : k.getBoundingClientRect(), { bottom: m = 0, left: _ = 0, right: f = 0, top: B = 0 } = w || {};
      if (B === 0 && m === 0 && _ === 0 && f === 0)
        return;
      const y = o.clientY < B || o.clientY > m || o.clientX < _ || o.clientX > f, h = ((g = l == null ? void 0 : l.current) == null ? void 0 : g.isConnected) ?? !1, D = h && ((C = l == null ? void 0 : l.current) == null ? void 0 : C.contains(o == null ? void 0 : o.target)), F = o.target === c.current;
      n && (F || y && !D && h) && i(!1);
    },
    [n, u, i, l]
  );
  return W(() => {
    c.current && (n ? c.current.showModal() : c.current.close());
  }, [c, n]), W(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  }, [d]), /* @__PURE__ */ S(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: z(
        a.dialog,
        { [a.hasBackdrop]: r },
        { [a.isFullScreen]: N },
        t
      ),
      "data-cxy-name": "dialog",
      id: "cxy-dialog",
      ref: c,
      ...b,
      children: [
        /* @__PURE__ */ e("div", { className: a.closeButtonWrapper, children: /* @__PURE__ */ e(
          x,
          {
            "aria-label": `Close ${p} Modal`,
            className: a.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ e(j, { size: "xl" })
          }
        ) }),
        /* @__PURE__ */ e("div", { className: a.dialogWrapper, children: s })
      ]
    }
  );
}, G = ({ children: s, className: t, ...r }) => /* @__PURE__ */ e("section", { className: z(a.panel, t), ...r, children: /* @__PURE__ */ e("div", { className: a.panelWrapper, children: s }) }), H = L(({ children: s, ...t }, r) => /* @__PURE__ */ e(x, { ref: r, variant: "ghost", ...t, children: s }));
v.Panel = G;
v.Trigger = H;
export {
  v as Dialog
};
